import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useParams } from "react-router";
import { fetchOfficeData } from "../../redux/features/office/officeSlice";
import { fetchUser } from "../../redux/features/user/userSlice";
import BatMenu from "./batMenu";
import Header from "./header";
import DownloadAppPopup from "../client/DownloadAppPopup";

function Layout(props) {
  const { officeName } = useParams();
  const { role } = props;
  const [showBatMenu, setShowBatMenu] = useState(role === "client"); // Toujours visible pour les clients

  const officeState = useSelector((state) => state.office);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (officeName) {
      // console.log(officeName, role)
      dispatch(fetchOfficeData(officeName));
      dispatch(fetchUser({ officeName, role }));
    }
  }, [officeName,role]);

  // console.log(user.data)
  return (
    <>
      {/* Afficher le header seulement pour admin et expert */}
      {role !== "client" && (
        <Header
          role={role}
          isLoading={user.loading}
          userName={user.data["name"]}
          userImage={user.data["picture"]}
          userId={user.data["id"]}
          supportWebCalling={user.data["supportWebCalling"]}
          notification={role === "admin" && user.data.notification}
          logo={
            officeState.data["logoImage"] == null
              ? "/assets/logo.svg"
              : officeState.data["logoImage"]
          }
          showBatMenu={showBatMenu}
          setShowBatMenu={setShowBatMenu}
        />
      )}
      <div className={`app-layout ${role === "client" ? "client-layout" : "admin-expert-layout"}`}>
        <BatMenu
          role={role}
          officeName={officeName}
          showBatMenu={showBatMenu}
          setShowBatMenu={setShowBatMenu}
          expertGain={user.data["expertGain"]}
        />
        {/* Popup désactivé temporairement
        {
          role == "client" ? <DownloadAppPopup /> : ""
        }
        */}
        <main className={`main-content ${showBatMenu ? "sidebar-open" : ""}`}>
          <div className="content-wrapper">
            <Outlet />
          </div>
          <footer className="modern-footer">
            <div className="footer-content">
              <p>
                A service provided by <a href="https://vooxhub.com" target="_blank" rel="noopener noreferrer">VooxHub</a> - 2025 © All rights reserved
              </p>
              <p>
                Developed by <a href="https://shield4Cloud.com" target="_blank" rel="noopener noreferrer">Shield4Cloud</a>
              </p>
            </div>
          </footer>
        </main>
      </div>
    </>
  );
}

export default Layout;
